import styled from "styled-components";

export const PlayerPerformancePageStack = styled.div.attrs({
  className: "space-y-6",
})``;

export const PlayerPerformanceWorkspaceSection = styled.div.attrs({
  className: "mt-8 space-y-4",
})``;

export const PlayerPerformanceMasterDetailGrid = styled.div.attrs({
  className: "grid gap-6 xl:grid-cols-[minmax(240px,320px)_minmax(0,1fr)]",
})``;

export const PlayerPerformancePlayerPanel = styled.div.attrs({
  className:
    "hidden overflow-hidden rounded-[24px] border border-[var(--brand-border)] bg-[rgba(255,255,255,0.04)] shadow-[0_16px_24px_rgba(0,0,0,0.18)] xl:block",
})``;

export const PlayerPerformancePlayerPanelHeader = styled.div.attrs({
  className: "space-y-2 border-b border-[var(--brand-border)] px-4 pb-3 pt-3",
})``;

export const PlayerPerformancePlayerPanelTitle = styled.p.attrs({
  className: "font-anonymous text-xs uppercase tracking-[0.22em] text-[var(--brand-highlight)]",
})``;

export const PlayerPerformancePlayerPanelBody = styled.div.attrs({
  className: "px-4 pb-4",
})``;

export const PlayerPerformanceSearchInput = styled.input.attrs({
  className: "brand-input w-full",
  placeholder: "Search players",
  type: "search",
})``;

export const PlayerPerformancePlayerList = styled.div.attrs({
  className: "max-h-[28rem] space-y-2 overflow-y-auto pr-1 pt-2",
})``;

export const PlayerPerformancePlayerButton = styled.button.attrs({
  className:
    "w-full rounded-[18px] border border-[var(--brand-border)] bg-[rgba(255,255,255,0.02)] px-3 py-3 text-left transition hover:border-[var(--brand-highlight)] hover:bg-[rgba(240,191,86,0.08)]",
})<{ $active?: boolean }>`
  border-color: ${({ $active }) => ($active ? "var(--brand-highlight)" : "var(--brand-border)")};
  background: ${({ $active }) =>
    $active ? "rgba(240, 191, 86, 0.12)" : "rgba(255, 255, 255, 0.02)"};
`;

export const PlayerPerformanceRecordsPanel = styled.div.attrs({
  className: "min-w-0 space-y-4",
})``;

export const PlayerPerformanceFilterBar = styled.div.attrs({
  className:
    "flex flex-col gap-3 rounded-[20px] border border-[var(--brand-border)] bg-[rgba(255,255,255,0.04)] px-4 py-3",
})``;

export const PlayerPerformanceMobileFilterBlock = styled.div.attrs({
  className: "w-full min-w-0 space-y-2 xl:hidden",
})``;

export const PlayerPerformanceFilterInputRow = styled.div.attrs({
  className:
    "flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between sm:gap-3",
})``;

export const PlayerPerformanceDesktopFilterRow = styled.div.attrs({
  className: "hidden min-w-0 w-full items-center justify-between gap-3 xl:flex",
})``;

export const PlayerPerformanceAthleteFilterRow = styled.div.attrs({
  className:
    "flex w-full min-w-0 flex-col gap-3 sm:flex-row sm:items-center sm:justify-between",
})``;

export const PlayerPerformanceFilterLabel = styled.label.attrs({
  className: "text-xs uppercase tracking-[0.18em] text-[var(--brand-muted)]",
})``;

export const PlayerPerformanceMobileSelectedPlayerCard = styled.div.attrs({
  className:
    "rounded-[18px] border border-[var(--brand-border)] bg-[rgba(255,255,255,0.02)] px-3 py-3 xl:hidden",
})``;

export const PlayerPerformanceSelectedPlayerWrap = styled.div.attrs({
  className: "hidden min-w-0 flex-1 xl:block",
})``;

export const PlayerPerformanceSelectedPlayerMeta = styled.p.attrs({
  className: "mt-2 text-sm text-[var(--brand-muted)]",
})``;

export const PlayerPerformanceMobileSelectedPlayerMeta = styled.p.attrs({
  className: "mt-2 text-xs leading-5 text-[var(--brand-muted)]",
})``;

export const PlayerPerformanceFilterSelectField = styled.div.attrs({
  className: "w-full min-w-0 sm:flex-1",
})``;

export const PlayerPerformanceFilterActions = styled.div.attrs({
  className: "flex w-full shrink-0 flex-col gap-2 sm:w-auto sm:flex-row sm:items-center",
})``;

export const PlayerPerformanceEmptyPlayers = styled.p.attrs({
  className: "rounded-[18px] border border-dashed border-[var(--brand-border)] px-4 py-6 text-sm leading-6 text-[var(--brand-muted)]",
})``;
